"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class FontClient extends authenticated_client_1.AuthenticatedClient {
    uploadCommonFonts(fontFiles) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`v1/fonts`, fontFiles);
            return response.payload;
        });
    }
    uploadFontsForProject(fontFiles, projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`v1/fonts/${projectId}`, fontFiles);
            return response.payload;
        });
    }
    getProjectFontInfo(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/fonts/${projectId}`);
            return response.payload;
        });
    }
    getProjectMissingFontNames(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/fonts/missing-fonts/${projectId}`);
            return response.payload;
        });
    }
    addMissingFontNamesToProject(projectId, missingFontNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/fonts/missing-fonts/${projectId}`;
            const response = yield this.httpPost(url, missingFontNames);
            return response.payload;
        });
    }
}
exports.FontClient = FontClient;
//# sourceMappingURL=font.client.js.map